import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-9_16",
  "use": "icon-9_16-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-9_16\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" /> \n\t<path d=\"M16,0H8A2,2,0,0,0,6,2V22a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V2A2,2,0,0,0,16,0Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol